import {AvalancheAddSymbolsState} from '@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheAddSymbolsState';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';

export class GameAvalancheAddSymbolsState extends AvalancheAddSymbolsState {
	protected startAddingNewSymbols(): void {

		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		(this.view as GameAvalancheReelsView).startAddingNewSymbolsWithExpectedWin(
			logic.getSpinResult().reels,
			logic.getSpinResult().symbolsToAdd,
			logic.getSpinResult().winLines,
		);
	}

	protected onFillingVoidFinished(): void {
		this.startAddingNewSymbols();

	}

	protected onAvalancheResponse(): void {
	}

	protected onAddingNewFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		logic.startNextRound();

		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
		this.emitDelayed(AvalancheReelsEvents.AVALANCHE_FINISHED);
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/states/GameAvalancheAddSymbolsState.ts